import BuscarReservacion from './BuscarReservacion';

const CompletarReservacion = () => {
  return (
    <div>
      <BuscarReservacion rutaDestino="resumen"/>
    </div>
  );
};

export default CompletarReservacion;
